var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcTwitter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.18347C11.5576 1.38487 11.0835 1.52009 10.585 1.58147C11.0938 1.26882 11.4847 0.773952 11.668 0.185096C11.1929 0.47377 10.6645 0.683802 10.1043 0.796969C9.65537 0.305936 9.01567 0 8.30769 0C6.94786 0 5.84522 1.12976 5.84522 2.52422C5.84522 2.72178 5.86766 2.91455 5.90975 3.09965C3.86346 2.99415 2.05003 1.98907 0.835165 0.461302C0.622867 0.835331 0.502221 1.26882 0.502221 1.73108C0.502221 2.60669 0.93617 3.37969 1.59738 3.83332C1.19336 3.81989 0.813655 3.70576 0.481646 3.51683C0.481646 3.52738 0.481646 3.53793 0.481646 3.54848C0.481646 4.77223 1.33084 5.79169 2.45593 6.02474C2.25018 6.08229 2.03227 6.11298 1.80781 6.11298C1.64882 6.11298 1.49451 6.09763 1.34393 6.06694C1.65817 7.06915 2.56722 7.8009 3.64368 7.82104C2.80196 8.49813 1.74047 8.90093 0.586392 8.90093C0.387187 8.90093 0.191723 8.88942 0 8.86545C1.08861 9.58281 2.38298 10 3.77367 10C8.30208 10 10.7786 6.15326 10.7786 2.81768C10.7786 2.70835 10.7758 2.59806 10.772 2.49065C11.2527 2.13484 11.6699 1.68984 12 1.18347Z",
    fill: "#B3B3B3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcTwitter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-twitter.a74e2131.svg";
export { ForwardRef as ReactComponent };